import { Modal } from "react-bootstrap";
import { Button } from "../common/Button";

const CALLBACK_CONFIRMATION_MESSAGE =
    "Your request has been submitted successfully. An available practitioner will contact you shortly at the phone number you provided. Please ensure your phone is available to receive the call.";

const WaitingScreen = ({ waitingScreenShow, waitingScreenClose }) => (
    <Modal
        backdropClassName
        backdrop="static"
        show={waitingScreenShow}
        onHide={waitingScreenClose}
        aria-labelledby="callback-confirmation-title"
        centered
        className="custom-dialog"
    >
        <Modal.Header className="border-0">
            <Modal.Title id="callback-confirmation-title">Request Submitted</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <p style={{ marginBottom: 0 }}>{CALLBACK_CONFIRMATION_MESSAGE}</p>
            <br />

            <div className="action-wrap">
                <Button
                    variant="primary"
                    className="success-btn"
                    onClick={waitingScreenClose}
                >
                    OK
                </Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default WaitingScreen;
